import type { RouteObject } from "react-router"

export const usersRoutes: RouteObject[] = [
  {
    path: "users",
    lazy: () => import("./users-page").then((m) => ({ Component: m.UsersPage })),
  },
]
